import React, { useState, useEffect } from "react";
import './Product_sidebar.css';
import axios from "axios";

const ProductSidebar = ({ filters, onFilterChange }) => {
  const [localFilters, setLocalFilters] = useState({
    colors: [],
    sizes: [],
    priceRange: [filters.priceRange.min, filters.priceRange.max], // Use the initial range from props
  });

  const handleFilterSelect = (type, value) => {
    setLocalFilters((prev) => {
      const updated = { ...prev };
      if (type === "colors" || type === "sizes") {
        if (updated[type].includes(value)) {
          updated[type] = updated[type].filter((item) => item !== value);
        } else {
          updated[type].push(value);
        }
      }
      onFilterChange(updated); // Notify parent about the filter change
      return updated;
    });
  };

  const handleClearFilters = () => {
    setLocalFilters({
      colors: [],
      sizes: [],
      priceRange: [1500, 55500],
    });
    window.location.reload();
  };

  const handlePriceChange = (e, bound) => {
    const value = parseInt(e.target.value, 10);
    const updatedFilters = {
      ...localFilters,
      priceRange:
        bound === "min"
          ? [value, localFilters.priceRange[1]]
          : [localFilters.priceRange[0], value],
    };
    setLocalFilters(updatedFilters);
    onFilterChange(updatedFilters); // Notify parent about the filter change
  };

  return (
    <div className="sidebar">

<div style={{display:"flex"}}>
      <h3>Filters</h3>
      <p className="clear-filters" onClick={handleClearFilters}>Clear</p>
      </div>
      {/* Color Filters */}
      <div className="filter-group">
        <h3 className="head_name">Color</h3>
        <hr />
        <div className="filter-options">
          {filters.colors.map((color) => (
            <button
              key={color}
              className={localFilters.colors.includes(color) ? "active" : ""}
              onClick={() => handleFilterSelect("colors", color)}
            >
              {color}
            </button>
          ))}
        </div>
      </div>

      {/* Size Filters */}
      <div className="filter-group">
        <h3 className="head_name">Size</h3>
        <hr />
        <div className="filter-options">
          {filters.sizes.map((size) => (
            <button
              key={size}
              className={localFilters.sizes.includes(size) ? "active" : ""}
              onClick={() => handleFilterSelect("sizes", size)}
            >
              {size}
            </button>
          ))}
        </div>
      </div>

      {/* Price Range */}
      <div className="filter-group">
        <h3 className="head_name">Price</h3>
        <hr />
        <div className="price-range">
          <input
            type="range"
            min={filters.priceRange.min}
            max={filters.priceRange.max}
            value={localFilters.priceRange[0]}
            onChange={(e) => handlePriceChange(e, "min")}
          />
          <input
            type="range"
            min={filters.priceRange.min}
            max={filters.priceRange.max}
            value={localFilters.priceRange[1]}
            onChange={(e) => handlePriceChange(e, "max")}
          />
        </div>
        <div>
          ₹{localFilters.priceRange[0]} - ₹{localFilters.priceRange[1]}
        </div>
      </div>
    </div>
  );
};



export default ProductSidebar;
